import React, { useContext, useRef } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import List from '../../../commonComponents/lists/List';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import SessionItem from '../SessionItem';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';

function SessionList({ t, query, languages }) {
  const { loggedUser } = useContext(LoggedUserContext);
  const tableId = 'sessionList';
  const tableEl = useRef(null);

  const columns = [
    {
      field: 'name',
      textAlign: 'center',
      title: t('academy_name'),
      template: item => renderToStaticMarkup(
        <SessionItem
          t={t}
          session={item}
          languages={languages}
          mySessionsMode
          isHostTrainerVisible
          loggedUser={loggedUser}
        />,
      ),
    },
  ];

  return (
    <List
      ref={tableEl}
      columns={columns}
      id={tableId}
      dataSourceURL="/table/access-session/list"
      dataSourceHeaders={{
        'Accept-Version': '1.0.0',
        'X-Gamification-API': 'Games',
      }}
      dataSourceParams={{ mySessions: true, populate: ['host', 'trainer'] }}
      query={query}
      defaultPageSize={12}
    />
  );
}

SessionList.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  query: PropTypes.shape({ category: PropTypes.string.isRequired }).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
};

export default translate(SessionList);
